import { defineStore } from 'pinia'

export interface MaintenanceGames {
  isMaintain: boolean
  startTime: string
  endTime: string
}
const STORE_NAME = 'maintenanceGames'

export const useMaintenanceGamesStore = defineStore(STORE_NAME, {
  state: (): MaintenanceGames => ({
    isMaintain: false,
    startTime: '',
    endTime: ''
  }),
  persist: false,
  actions: {
    setMaintenanceGames(isMaintain: boolean, startTime = '', endTime = '') {
      this.isMaintain = isMaintain
      this.startTime = startTime
      this.endTime = endTime
    }
  }
})
